export const getHouseDataQuery = `
  query simpleAddressData($postalCode: String!, $houseNumber: Int!, $houseNumberAddition: String = null) {
    simpleAddressData(postalCode: $postalCode, houseNumber: $houseNumber, houseNumberAddition: $houseNumberAddition) {
      postalCode
      houseNumber
      houseNumberAddition
      street
      place
    }
  }
`;
